import React, { useState } from "react"
import ReactPlayer from "react-player";
import { StaticImage } from "gatsby-plugin-image"

export default function Video(props) {
  const [play, setPlay] = useState(false);

  function playVideo() {
    setPlay(true);
  }

  return (
    <div className={`relative ${props.videoStyles}`}>
      <div className="embed-responsive aspect-ratio-16/9">
        <ReactPlayer 
            className="embed-responsive-item"
            url={props.videoSrc}
            width="100%"
            height="100%"
            controls={true}
            playing={play}
          ></ReactPlayer>
          <div className={`cursor-pointer absolute inset-0 ${play === true ? 'hidden' : ''}`} onClick={playVideo} onKeyDown={playVideo} aria-hidden="true">
            <StaticImage src="../images/play-overlay.png" alt="overlay" />
          </div>
      </div>
    </div>
  );
}
